/**
 * @name prepareConfirmBtnsText
 * @param actionType {Number} - Тип события
 */
export const prepareConfirmBtnsText = (actionType) => {
  switch (actionType) {
  case 'deactivate':
    return {
      confirmBtnText: 'Ok',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  default:
    return {
      confirmBtnText: '',
      cancelBtnText: '',
    };
  }
};
